import { StatusAlert } from '@wemolo/components'
import classNames from 'classnames'
import React, { FC } from 'react'
import styles from './StatusAlert.module.css'

type StatusAlertProps = React.ComponentProps<typeof StatusAlert>

export const StatusAlertSmall: FC<StatusAlertProps> = ({ className, ...props }) => (
    <StatusAlert {...props} className={classNames(styles.small, className)} />
)
